import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionableCartSection, {
  SECTION_TYPES,
} from './actionable_cart_section';
import { Box } from '@mui/material';
import EmptyCart from 'components/pages/cart/empty_cart';
import { MarketLink } from '@market/react';
import { localizedShopPath } from 'utilities/locales';
import { useFeatureFlags } from 'components/context/feature_flags';
import { trackCdp } from 'utilities/tracking';
import CDP_EVENT_NAMES from 'constants/cdp_events';
import { useOrderDetails } from 'components/context/order_details';
import {
  getKioskPricingContext,
  isKioskOnlySoftwareInCart,
} from 'utilities/software';

const ActionableCart = (props) => {
  const { t } = useTranslation();
  const { saasOnShopEnabled } = useFeatureFlags();
  const { trackingData } = useOrderDetails();

  const {
    orderData,
    shipQuotes,
    cartClient,
    orderRefresh,
    softwareUnavailable,
  } = props;

  const cartSummary = orderData.cart_summary;
  const isReadOnly = Boolean(orderData.is_hardware_rental_order);
  const { isPnpSubscribed, locationCount, kioskDeviceCount, k1aDeviceCount } =
    getKioskPricingContext(orderData);

  const softwareCart = cartSummary
    .filter(({ is_software }) => is_software)
    .map((item) => (softwareUnavailable ? { ...item, plan: null } : item));
  const hardwareCart = cartSummary.filter(({ is_software }) => !is_software);

  const modifySoftwareSectionButton = (
    <MarketLink
      href={`${localizedShopPath('v2')}/software?source=cart`}
      onClick={() => {
        trackCdp({
          name: CDP_EVENT_NAMES.SAAS_ON_SHOP.MODIFY_SOFTWARE,
          params: {
            feature: 'shop',
            order_number: trackingData.order?.number,
          },
        });
      }}
      className="medium-20"
    >
      {t('cart.label.modifySoftware')}
    </MarketLink>
  );

  const emptyComponent = (
    <Box sx={{ py: 4, px: { xs: '5%', lg: '15%' } }}>
      <EmptyCart />
    </Box>
  );

  const cartSections = [
    // eslint-disable-next-line react/jsx-key
    <ActionableCartSection
      sectionTitle={t('common.hardware')}
      cartSection={hardwareCart}
      shipQuotes={shipQuotes}
      cartClient={cartClient}
      orderRefresh={orderRefresh}
      emptyComponent={emptyComponent}
      sectionType={SECTION_TYPES.HARDWARE}
      bopisEligible={orderData.bopis_eligible}
      isReadOnly={isReadOnly}
    />,
    // eslint-disable-next-line react/jsx-key
    <ActionableCartSection
      orderData={orderData}
      sectionTitle={t('common.software')}
      cartSection={softwareCart}
      shipQuotes={shipQuotes}
      cartClient={cartClient}
      orderRefresh={orderRefresh}
      sectionType={SECTION_TYPES.SOFTWARE}
      isPnpSubscribed={isPnpSubscribed}
      locationCount={locationCount}
      kioskDeviceCount={kioskDeviceCount}
      k1aDeviceCount={k1aDeviceCount}
      isReadOnly={isReadOnly}
      // Kiosk only software should not have the modify button since it goes to our software page
      {...(saasOnShopEnabled && !isKioskOnlySoftwareInCart(orderData)
        ? { titleButton: modifySoftwareSectionButton }
        : {})}
    />,
  ];

  return (
    <div>
      {cartSections.map((element, index) => (
        <Box
          key={index}
          sx={{
            marginTop: 4,
          }}
        >
          {element}
        </Box>
      ))}
    </div>
  );
};

export default ActionableCart;
